import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { paths } from '@/utils/path'
import { useLocationList } from '../../hooks/use-location-list'

const LocationsList = () => {
    const {
        locations,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
    } = useLocationList()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                    {
                        path: paths.warehouseLocations,
                        title: 'Locations',
                    },
                ]}
            />

            <Paper className="mt-2 space-y-2">
                <FilterBar
                    storageKey="warehouse-locations"
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={locations}
                        rowKey={(row) => row.id}
                        size="small"
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: 'Search locations...',
                            },
                            settings: {
                                show: true,
                                storageKey: 'warehouse-locations',
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default LocationsList
